import type { MeResponse } from "@station/contracts";
import { useMe } from "./session.js";

export interface TenantShape {
  /** Kullanıcının GÖRDÜĞÜ istasyon sayısı 1 ise: arayüz sadeleşir. */
  isSingleStation: boolean;
  isSingleCompany: boolean;
  /** Tek istasyon modunda gidilecek istasyon (kapsamdan biliniyorsa). */
  singleStationId: string | null;
  showScopeSelector: boolean;
  showRegions: boolean;
  showCompanySelector: boolean;
  /** Ana sayfa: tek istasyonda doğrudan istasyon özeti, zincirde genel bakış. */
  homeVariant: "station" | "overview";
}

/**
 * Kiracının "şekli" → arayüz davranışı. TEK istasyonlu kiracıda kapsam seçici ve bölge kavramı gizlenir;
 * ikinci istasyon eklendiğinde arayüz KENDİLİĞİNDEN çoklu moda geçer (Prompt 04, AGENTS.md §2).
 * Bu mantık yalnızca burada yaşar; bileşenler `stationCount`'a doğrudan bakmaz.
 *
 * Not: ölçüt kiracıdaki değil, KULLANICININ GÖRDÜĞÜ istasyon sayısıdır — zincirde tek istasyona atanmış bir
 * istasyon müdürü de sade arayüzü görür.
 */
export function computeTenantShape(tenant: MeResponse["activeTenant"]): TenantShape {
  const stationCount = tenant?.stationCount ?? 0;
  const single = stationCount <= 1;
  return {
    isSingleStation: single,
    isSingleCompany: (tenant?.companyCount ?? 0) <= 1,
    singleStationId: single && tenant?.stationScope?.length === 1 ? tenant.stationScope[0]! : null,
    showScopeSelector: !single,
    showRegions: !single,
    showCompanySelector: (tenant?.companyCount ?? 0) > 1,
    homeVariant: single ? "station" : "overview",
  };
}

export function useTenantShape(): TenantShape {
  return computeTenantShape(useMe().data?.activeTenant ?? null);
}
